import { Expose, Type } from "class-transformer";

export class CallToActionProductModel {
  constructor() {
    this.callToActionId = 0;
    this.materialCode = "";
    this.materialName = "";
    this.productBrand = "";
    this.isActionSuccess = false;
    this.actionSuccessDate = null;
    this.reasons = [];
  }

  @Expose({ name: "callToActionId" })
  callToActionId: number;

  @Expose({ name: "materialCode" })
  materialCode: string;

  @Expose({ name: "materialName" })
  materialName: string;

  @Expose({ name: "productBrand" })
  productBrand: string;

  @Expose({ name: "isActionSuccess" })
  isActionSuccess: boolean;

  @Expose({ name: "actionSuccessDate" })
  actionSuccessDate: string | null;

  @Expose({ name: "reasons" })
  reasons: string[];
}

export class CallToActionActivityModel {
  constructor() {
    this.activityType = "";
    this.productGroup = "";
    this.products = [];
  }

  @Expose({ name: "activityType" })
  activityType: string;

  @Expose({ name: "productGroup" })
  productGroup: string;

  @Expose({ name: "products" })
  @Type(() => CallToActionProductModel)
  products: CallToActionProductModel[];

  get isActionSuccess(): boolean {
    if (!this.products || this.products.length === 0) return false;
    return this.products.every((p) => p.isActionSuccess);
  }
}

export class CallToActionDataModel {
  constructor() {
    this.customerCode = "";
    this.customerName = null;
    this.bu = null;
    this.region = null;
    this.province = null;
    this.activitys = [];
  }

  @Expose({ name: "customerCode" })
  customerCode: string;

  @Expose({ name: "customerName" })
  customerName: string | null;

  @Expose({ name: "bu" })
  bu: string | null;

  @Expose({ name: "region" })
  region: string | null;

  @Expose({ name: "province" })
  province: string | null;

  @Expose({ name: "activitys" })
  @Type(() => CallToActionActivityModel)
  activitys: CallToActionActivityModel[];
}
